import React from 'react';
import { Header, Button, Grid, Segment, Loader, Table, Icon, Form, Popup } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';

import { DateTimePicker } from 'react-widgets';
import { IconHeader } from '../../../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class ContractPauses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],

            addPauseMode: false,

            editPause: false,

            documentNumber: null,
            startDate: null,
            endDate: null,
            comment: null,

            optLock: null,
            id: null,

            main: null

        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.addPause = this.addPause.bind(this);
        this.editPause = this.editPause.bind(this);
        this.getPauses = this.getPauses.bind(this);
        this.deletePause = this.deletePause.bind(this);
    }

    componentWillMount() {
        this.setState({
            main: localStorage.getItem('main') === 'true'
        });
        this.getPauses();
    }

    getPauses() {
        let obj = { id: this.props.contractId };
        axios.post('employment-contract-pause/all', { ...obj })
            .then(res => {
                this.setState({ data: res.data });
            })
            .catch(err => {
                console.log('Failed to fetch contract pauses.');
            });
    }

    addPause() {
        let obj = {
            employmentContract: { id: this.props.contractId },
            documentNumber: this.state.documentNumber,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            comment: this.state.comment
        };

        axios.post('employment-contract-pause/add', { ...obj })
            .then(res => {
                toast('Dodavanje mirovanja ugovora je uspješno izvršeno.');
                this.setState({ addPauseMode: false });
                this.getPauses();
            })
            .catch(err => {
                toast('Došlo je do greške! Dodavanje mirovanja nije uspješno izvršeno.');
            });
    }

    editPause() {
        let obj = {
            documentNumber: this.state.documentNumber,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            comment: this.state.comment,
            optLock: this.state.optLock,
            id: this.state.id
        };

        axios.put('employment-contract-pause/edit', { ...obj })
            .then(res => {
                toast('Izmjena mirovanja je uspješno izvršeno.');
                this.setState({ editPause: false });
                this.getPauses();
            })
            .catch(err => {
                toast('Došlo je do greške! Izmjena mirovanja nije uspješno izvršena.');
            });
    }

    deletePause(id) {
        let obj = { id };

        axios.delete(`employment-contract-pause/delete/${id}`)
            .then(res => {
                toast('Brisanje mirovanja je uspješno izvršeno.');
                this.getPauses();
            })
            .catch(err => {
                toast('Došlo je do greške! Brisanje mirovanja nije uspješno izvršena.');
            });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        const {
            data, editPause, addPauseMode, main
        } = this.state;
        return (
            <div >
                {/* <h3>Mirovanja prava i obaveza iz radnog odnosa */}
                {/*    <Popup */}
                {/*        content="Zatvori" */}
                {/*        position="top center" */}
                {/*        trigger={ */}
                {/*            <Button */}
                {/*                floated='right' */}
                {/*                circular */}
                {/*                icon="close" */}
                {/*                size="small" */}
                {/*                basic="true" */}
                {/*                onClick={this.props.close} */}
                {/*            /> */}
                {/*        } */}
                {/*    /></h3> */}
                <Segment.Group>
                    <Segment secondary>

                        <Header as="h3">
                            <span style={{ color: 'black' }}>Mirovanja prava i obaveza iz radnog odnosa</span>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic="true" floated="right" name="close" onClick={this.props.close} />}
                                    content="Zatvori"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                        </Header>
                    </Segment>
                    <Segment>
                        <Table celled selectable compact >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Broj ugovora</Table.HeaderCell>
                                    <Table.HeaderCell>Broj odluke</Table.HeaderCell>
                                    <Table.HeaderCell>Datum početka mirovanja</Table.HeaderCell>
                                    <Table.HeaderCell>Datum kraja mirovanja</Table.HeaderCell>
                                    <Table.HeaderCell>Napomena</Table.HeaderCell>
                                    {(main && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' || localStorage.getItem('associate') == 'true') &&
                                    <Table.HeaderCell as="th" verticalAlign="middle" textAlign="center">
                                        <Popup
                                            content="Dodaj mirovanje"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    icon="add"
                                                    size="small"
                                                    basic="true"
                                                    color="blue"
                                                    circular
                                                    onClick={() => this.setState({ addPauseMode: true })}
                                                />}
                                        />
                                    </Table.HeaderCell>}
                                </Table.Row>
                            </Table.Header>
                            { (data && data.length) || addPauseMode ? <Table.Body>
                                {addPauseMode && <Table.Row>
                                    <Table.Cell verticalAlign="middle">
                                        {this.props.number}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        <Form>
                                            <Form.Field>
                                                <input
                                                    value={this.state.documentNumber}
                                                    onChange={(e) => this.setState({ documentNumber: e.target.value })}
                                                    name="documentNumber"
                                                    placeholder="Unesite broj odluke"
                                                />
                                            </Form.Field>
                                        </Form>
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        <Form>
                                            <Form.Field>
                                                <DateTimePicker
                                                    format="D. M. YYYY."
                                                    time={false}
                                                    onChange={this.handleDateChange.bind(null, 'startDate')}
                                                    value={this.state.startDate}
                                                />
                                            </Form.Field>
                                        </Form>
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        <Form>
                                            <Form.Field>
                                                <DateTimePicker
                                                    format="D. M. YYYY."
                                                    time={false}
                                                    onChange={this.handleDateChange.bind(null, 'endDate')}
                                                    value={this.state.endDate}
                                                />
                                            </Form.Field>
                                        </Form>
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        <Form >
                                            <Form.Field>
                                                <input
                                                    value={this.state.comment}
                                                    onChange={(e) => this.setState({ comment: e.target.value })}
                                                    name="comment"
                                                    placeholder="Unesite napomenu"
                                                />
                                            </Form.Field>
                                        </Form>
                                    </Table.Cell>
                                    {(main || localStorage.getItem('associate') == 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && <Table.Cell textAlign="center" verticalAlign="middle" >
                                        <Button color="blue" circular icon="check" onClick={this.addPause} />
                                        <Button
                                            color="blue"
                                            basic="true"
                                            circular
                                            icon="close"
                                            onClick={() => this.setState({
                                                addPauseMode: false, comment: null, documentNumber: null, startDate: null, endDate: null
                                            })}
                                        />
                                    </Table.Cell>}
                                </Table.Row>}
                                {data.map((el, index) => (
                                    <Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle">
                                            {el.employmentContract.number}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {editPause === index ?
                                                <Form noValidate>
                                                    <Form.Field>
                                                        <input
                                                            value={this.state.documentNumber}
                                                            onChange={(e) => this.setState({ documentNumber: e.target.value })}
                                                            name="documentNumber"
                                                            placeholder="Unesite broj odluke"
                                                        />
                                                    </Form.Field>
                                                </Form>
                                                : el.documentNumber ? el.documentNumber : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {editPause === index ?
                                                <Form noValidate>
                                                    <Form.Field>
                                                        <DateTimePicker
                                                            format="D. M. YYYY."
                                                            time={false}
                                                            onChange={this.handleDateChange.bind(null, 'startDate')}
                                                            value={this.state.startDate ? new Date(this.state.startDate) : null}
                                                        />
                                                    </Form.Field>
                                                </Form>
                                                : el.startDate ? moment(el.startDate).format('D. M. YYYY.') : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {editPause === index ?
                                                <Form noValidate>
                                                    <Form.Field>
                                                        <DateTimePicker
                                                            format="D. M. YYYY."
                                                            time={false}
                                                            onChange={this.handleDateChange.bind(null, 'endDate')}
                                                            value={this.state.endDate ? new Date(this.state.endDate) : null}
                                                        />
                                                    </Form.Field>
                                                </Form>
                                                : el.endDate ? moment(el.endDate).format('D. M. YYYY.') : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {editPause === index ?
                                                <Form noValidate>
                                                    <Form.Field>
                                                        <input
                                                            value={this.state.comment}
                                                            onChange={(e) => this.setState({ comment: e.target.value })}
                                                            name="comment"
                                                            placeholder="Unesite napomenu"
                                                        />
                                                    </Form.Field>
                                                </Form>
                                                : el.comment ? el.comment : ''}
                                        </Table.Cell>
                                        {(main || localStorage.getItem('associate') == 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && <Table.Cell verticalAlign="middle" textAlign="center">
                                            {editPause === index ? <div>
                                                <Button color="blue" circular icon="check" onClick={this.editPause} />
                                                <Button
                                                    color="blue"
                                                    basic="true"
                                                    circular
                                                    icon="close"
                                                    onClick={() => this.setState({
                                                        editPause: false, academicTitle: null, documentNumber: null, startDate: null, endDate: null
                                                    })}
                                                />
                                            </div>
                                                : <div>
                                                    <Button
                                                        onClick={() => this.setState({
                                                            editPause: index,
                                                            comment: el.comment,
                                                            documentNumber: el.documentNumber,
                                                            startDate: el.startDate,
                                                            endDate: el.endDate,
                                                            optLock: el.optLock,
                                                            id: el.id
                                                        })}
                                                        basic="true"
                                                        circular
                                                        icon="pencil"
                                                        size="small"
                                                        color="green"
                                                    />
                                                    <Button
                                                        onClick={() => this.deletePause(el.id)}
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="small"
                                                        color="red"
                                                    />
                                                </div>}
                                        </Table.Cell>}
                                    </Table.Row>))}
                            </Table.Body> :
                            <Table.Body>
                                    <Table.Row>
                                    <Table.Cell
                                            colSpan={this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' ? '6' : '5'}
                                        >
                                            Nema unesenih podataka.
                                        </Table.Cell>
                                </Table.Row>
                                </Table.Body>}
                        </Table>
                    </Segment>
                </Segment.Group>

                <br />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/profile/Employee/ContractPauses.js